<template>
  <div>
    <common-dialog ref="dialog" width="800px" :show-save-button="false" title="明细进度" id-key="ProductionProgressId" @close-saved="$emit('close-saved')">
      <el-table ref="list" border :data="tableData" style="width: 100%">
        <el-table-column key="key1" prop="OrderProductNo" label="布产单号" min-width="120"></el-table-column>
        <el-table-column key="key2" prop="OrderDate" label="单据日期" min-width="120"></el-table-column>
        <el-table-column key="key3" prop="ProductName" label="存货名称" min-width="120"></el-table-column>
        <el-table-column key="key4" v-if="isShow4" prop="InRate4" label="注塑" min-width="120"></el-table-column>
        <el-table-column key="key9" v-if="isShow9" prop="InRate9" label="胶件加工" min-width="120"></el-table-column>
        <el-table-column key="key5" v-if="isShow5" prop="InRate5" label="特殊加工" min-width="120"></el-table-column>
        <el-table-column key="key6" v-if="isShow6" prop="InRate6" label="配件" min-width="120"></el-table-column>
        <el-table-column key="key7" v-if="isShow7" prop="InRate7" label="装配" min-width="120"></el-table-column>
        <el-table-column key="key8" v-if="isShow8" prop="InRate8" label="组合" min-width="120"></el-table-column>
      </el-table>

      <template slot="footer">
        <el-button type="primary" @click="enter">确定</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog
  },
  data() {
    return {
      api: require('@/api/pr/prProductionProgress').default,
      // data: {
      //   ProductionProgressId: 0,
      //   OrderId: 0,
      //   OrderProductId: 0,
      //   Progress: "",
      //   ProgressStr: "",
      //   InRate: 0,
      //   InQuantity: 0,
      //   Remarks: "",
      //   ProductNo: "",
      //   ProductName: "",
      //   ProductSpec: "",
      //   OrderNo: "",
      //   OrderDate: "",
      //   OrderProductNo: "",
      // },
      isShow4: false,
      isShow5: false,
      isShow6: false,
      isShow7: false,
      isShow8: false,
      isShow9: false,
      tableData: [],
      safetyStock: false,
      minStock: false,
      saleOrderConsumption: false,
      tempData: []
    }
  },
  methods: {
    setData(obj) {
      this.isShow4 = false
      this.isShow5 = false
      this.isShow6 = false
      this.isShow7 = false
      this.isShow8 = false
      this.isShow9 = false

      this.api.info(obj).then(res => {
        if (res.Code === 0) {
          let data = res.Data

          let o = {}
          if (data.length > 0) {
            let { ProgressStr, InRate, ...rest } = data[0]
            o = rest
          }
          console.log(o)

          data.forEach(item => {
            if (item.ProgressStr === '注塑') {
              this.isShow4 = true
              o.InRate4 = Number(item.InRate.toFixed(3))
            }
            if (item.ProgressStr === '特殊加工') {
              this.isShow5 = true
              o.InRate5 = Number(item.InRate.toFixed(3))
            }
            if (item.ProgressStr === '胶件加工') {
              this.isShow9 = true
              o.InRate9 = Number(item.InRate.toFixed(3))
            }
            if (item.ProgressStr === '配件') {
              this.isShow6 = true
              o.InRate6 = Number(item.InRate.toFixed(3))
            }
            if (item.ProgressStr === '装配') {
              this.isShow7 = true
              o.InRate7 = Number(item.InRate.toFixed(3))
            }
            if (item.ProgressStr === '组合') {
              this.isShow8 = true
              o.InRate8 = Number(item.InRate.toFixed(3))
            }
          })

          let arr = []
          arr.push(o)

          arr.forEach(item => {
            item.OrderDate = this.$commonJs.toDateString(item.OrderDate)
          })

          this.tableData = arr
        }
      })
    },
    enter() {
      this.close()
    }
  }
}
</script>
